import { toast } from 'react-toastify';

export const NOTIFICATION_TYPE_INFO = 'info';
export const NOTIFICATION_TYPE_SUCCESS = 'success';
export const NOTIFICATION_TYPE_WARNING = 'warning';
export const NOTIFICATION_TYPE_ERROR = 'error';

export function toasterNotification(type, title, message, autoCloseTime = 5000) {
    toast.dismiss();

    const content = (
        <div>
            {title && <strong>{title}</strong>}
            {title && message && <br />}
            {message && <span>{message}</span>}{' '}
        </div>
    );

    const defaultOptions = {
        autoClose: autoCloseTime,
    };

    switch (type) {
        case NOTIFICATION_TYPE_INFO:
            toast.info(content, {
                style: { backgroundColor: '#FFFAEB', color: '#3E3E4A' },
                ...defaultOptions,
            });
            break;
        case NOTIFICATION_TYPE_SUCCESS:
            toast.success(content, {
                style: { backgroundColor: '#ECFDF3', color: '#75BD2F' },
                ...defaultOptions,
            });
            break;
        case NOTIFICATION_TYPE_WARNING:
            toast.warning(content, defaultOptions);
            break;
        case NOTIFICATION_TYPE_ERROR:
            toast.error(content, {
                style: { backgroundColor: '#FEF3F2', color: '#B42318' },
                ...defaultOptions,
            });
            break;
        default:
    }
}
